import { render, staticRenderFns } from "./PopupScheduleSetups.vue?vue&type=template&id=4068bf28&scoped=true&"
import script from "./PopupScheduleSetups.vue?vue&type=script&lang=js&"
export * from "./PopupScheduleSetups.vue?vue&type=script&lang=js&"
import style0 from "./PopupScheduleSetups.vue?vue&type=style&index=0&id=4068bf28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4068bf28",
  null
  
)

export default component.exports